export function StreamingIndicator() {
  return (
    <div className="mb-4 flex flex-row items-center justify-start gap-1">
      <div className="flex flex-row items-center gap-1.5 rounded-lg bg-muted/50 px-3 py-2.5">
        <div
          className="h-2 w-2 animate-bounce rounded-full bg-primary/70"
          style={{ animationDelay: "0ms", animationDuration: "600ms" }}
        />
        <div
          className="h-2 w-2 animate-bounce rounded-full bg-primary/70"
          style={{ animationDelay: "150ms", animationDuration: "600ms" }}
        />
        <div
          className="h-2 w-2 animate-bounce rounded-full bg-primary/70"
          style={{ animationDelay: "300ms", animationDuration: "600ms" }}
        />
      </div>
    </div>
  );
}
